/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useHistory, useParams } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import ManufacturersApi from '../../../../services/api/ManufacturersApi';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import validationSchema from '../validationSchema';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';

export default function ManufacturerEdit(): JSX.Element {
  const { id } = useParams();
  const [itemData, setItemData] = useState({
    name: '',
    address: '',
    dataArrived: false,
  });
  const history = useHistory();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    let res = null;
    if (id) {
      res = await ManufacturersApi.update(id, values);
    } else {
      res = await ManufacturersApi.create(values);
    }
    if (res.status === StatusCodes.OK) {
      history.push('/manufacturers');
    } else {
      setSubmitting(false);
    }
  };

  const getItem = async () => {
    const res = await ManufacturersApi.get(id);
    const newItemData = { ...res.data, dataArrived: true, address: res.data?.contractor?.address };
    setItemData(newItemData);
  };

  useEffect(() => {
    if (id) {
      getItem(id);
    }
  }, []);

  return (
    <WhitePad>
      <TitleComponent
        onLeftHandler={() => {
          history.goBack();
        }}
        title={`${id ? 'Edit ' : 'Create '} Manufacturer`}
      />

      {id && itemData.dataArrived === false ? null : (
        <Formik
          initialValues={{
            name: itemData.name,
            address: itemData.address,
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => {
            return saveItem(values, setSubmitting);
          }}
        >
          {({ values, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
            <FormWrapper>
              <form onSubmit={handleSubmit} autoComplete="off" style={{ width: '440px' }}>
                <FormRow>
                  <TextInputComponent
                    name="name"
                    label="Name"
                    value={values.name}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    cols={12}
                  />
                </FormRow>
                <FormRow>
                  <TextInputComponent
                    name="address"
                    label="Address"
                    value={values.address}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    cols={12}
                  />
                </FormRow>
                <PrimaryButton type="submit" isSubmitting={isSubmitting} title="Save" />
              </form>
            </FormWrapper>
          )}
        </Formik>
      )}
    </WhitePad>
  );
}
